/**
 * Profile
 * @type {boolean}
 */
export const debug = process.env.NODE_ENV === 'development';
